import { FreshworksHelper } from "app/helpers/freshworksHelper";
import isPublicView from "app/utils/publicViewUtils";
import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import AccountControlsMenu from "./components/AccountControlsMenu/AccountControlsMenu";
import LossLimitsContainer from "./components/LossLimits/LossLimitsContainer";
import SelfExclusion from "./components/SelfExclusion/SelfExclusion";

import "./AccountControlsScreen.scss";
import AccountHeader from "./components/AccountHeader/AccountHeader";

export enum AccountControlRoutes {
  LossLimits = "losslimits",
  SelfExclusion = "selfexclusion",
}
type RouteParams = {
  id?: AccountControlRoutes;
};

/**
 * AccountControlsScreen handles the routing and display of account control features
 * including loss limits and self exclusion settings.
 */
const AccountControlsScreen: React.FC = () => {
  // if id not set, show the menu
  // if it is set, show the corresponding component
  const { id } = useParams<RouteParams>();
  const history = useHistory();
  useEffect(() => {
    FreshworksHelper.showWidget();
    return () => {
      if (!isPublicView()) {
        FreshworksHelper.hideWidget();
      }
    };
  }, []);

  const renderContent = () => {
    if (!id) {
      return <AccountControlsMenu />;
    }
    // if invalid route, redirect to the menu
    if (!Object.values(AccountControlRoutes).includes(id)) {
      history.push("/account/controls/");
    }

    if (id === AccountControlRoutes.LossLimits) {
      return <LossLimitsContainer />;
    }
    if (id === AccountControlRoutes.SelfExclusion) {
      return <SelfExclusion />;
    }
    return null;
  };

  return (
    <div className="account-controls">
      <AccountHeader id="account-links-controls" />
      <div className="account-controls__content">{renderContent()}</div>
    </div>
  );
};

export default AccountControlsScreen;
